// 订单记录
const orderRecord = [
  {
    path: '/order-record',
    name: 'orderRecordPage',
    meta: { tag: '订单记录' },
    component: () => import('@/pages/OrderRecordPage')
  }
]

export default orderRecord
